// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LvdG3n78lk8qJWOlublT{width:100%;height:100%;display:flex}.LvdG3n78lk8qJWOlublT .prakZeSirGAHG4LkcEU9{position:relative}.LvdG3n78lk8qJWOlublT .prakZeSirGAHG4LkcEU9 .o6jlrT16gwMeKsUWnErx{position:absolute;top:8px;left:-46px}.LvdG3n78lk8qJWOlublT .R2YG32azsJEQzZtJ6Mg3{height:100%;padding-bottom:24px;position:relative}.LvdG3n78lk8qJWOlublT .vrOTre2qAw0a6yTEpbst{padding-bottom:16px;padding-left:80px;padding-right:75px}.VfISf3HiU6sIJKoh71Ha{background-color:var(--gray-a-15);border-radius:4px;margin-bottom:24px;padding:3.5px 8px;display:inline-block}.jpYT4dR9BIPXVzVRlJzD{margin-bottom:20px}.Fx11EZVmc40WHyPVdADN{padding:30px 0}.EDwLsJ1UIuUgBTHOuLDb{flex-direction:column;width:100%;min-width:620px;max-width:620px;padding-bottom:0;display:flex;overflow-y:auto}.Haox7NSeN8AsUSr9chsQ{border-left:1px solid var(--border-neutral-default);width:100%;padding:0;display:flex}.Zv1fKiLu6gETU6DHjKB1{height:100%}.UrvLUU201Fsq1inLoAJb{padding-top:30px}._wM5MIHGB8olLuVbOM8V{margin-bottom:6px}._wM5MIHGB8olLuVbOM8V:last-of-type{margin-bottom:0}.slajR2_fhaYlZZWFlbCS{justify-content:flex-end;gap:8px;padding:40px 80px 64px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `LvdG3n78lk8qJWOlublT`,
	"titleWrap": `prakZeSirGAHG4LkcEU9`,
	"backButton": `o6jlrT16gwMeKsUWnErx`,
	"wrapCreate": `R2YG32azsJEQzZtJ6Mg3`,
	"header": `vrOTre2qAw0a6yTEpbst`,
	"label": `VfISf3HiU6sIJKoh71Ha`,
	"guidelineAlert": `jpYT4dR9BIPXVzVRlJzD`,
	"box": `Fx11EZVmc40WHyPVdADN`,
	"box__main": `EDwLsJ1UIuUgBTHOuLDb`,
	"boxMain": `EDwLsJ1UIuUgBTHOuLDb`,
	"box__preview": `Haox7NSeN8AsUSr9chsQ`,
	"boxPreview": `Haox7NSeN8AsUSr9chsQ`,
	"loading": `Zv1fKiLu6gETU6DHjKB1`,
	"section": `UrvLUU201Fsq1inLoAJb`,
	"section__box": `_wM5MIHGB8olLuVbOM8V`,
	"sectionBox": `_wM5MIHGB8olLuVbOM8V`,
	"actions": `slajR2_fhaYlZZWFlbCS`
};
export default ___CSS_LOADER_EXPORT___;
